module.exports = __webpack_public_path__ + "static/sq2_book-ad3812f3055c16e94b3416fb570296ee.jpg";